import React, { useState, useEffect } from "react";
import SignInForm from "components/auth/SignInForm";
import Footer from "components/footer/Footer";
import SectionImage from "assets/images/section-bg.svg";
import GirlWithDog from "../../assets/images/homeImage.png";

const Login = () => {
  return (
    <div className="w-full tw-h-full">
      {/* //1st main div */}
      <div className="tw-w-full tw-flex">
        <div className="tw-w-full lg:tw-w-[50%] tw-flex tw-flex-col tw-relative tw-bg-[#EFEFEF] md:tw-rounded-r-[30px]">
          <div
            className="tw-w-full tw-h-screen lg:tw-h-full lg:tw-absolute tw-inset-0 tw-bg-[ #EFEFEF] tw-z-10"
            style={{ mixBlendMode: "luminosity" }}
          >
            <img
              src={SectionImage}
              className="tw-h-full tw-w-full tw-object-cover"
              alt="login"
            />
          </div>
          <div className="tw-w-full tw-absolute tw-mx-auto tw-top-[100px] md:tw-top-[50px] xl:tw-top-[100px] tw-z-20">
            <SignInForm />
          </div>
        </div>

        <div className="tw-hidden lg:tw-flex lg:tw-w-[55%] tw:w-h-full lg:tw-ml-[-2rem]">
          <div className="md:tw-w-full md:tw-h-full">
            <img
              src={GirlWithDog}
              className="tw-w-full tw-h-full"
              alt="girl with dog"
            />
          </div>
        </div>
      </div>
      {/* //2nd main div */}
      <div className="tw-flex tw-w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Login;
